import {
  TEMPLATE_CATEGORIES_FETCH_API,
  TEMPLATE_CATEGORIES_FETCH_START,
  TEMPLATE_CATEGORY_CREATE_API,
  TEMPLATE_CATEGORY_CREATE_API_FULFILLED,
  TEMPLATE_CATEGORY_CREATE_API_REJECTED,
  TEMPLATE_CATEGORY_CREATE_START,
  TEMPLATE_CATEGORY_DELETE_API,
  TEMPLATE_CATEGORY_DELETE_API_FULFILLED,
  TEMPLATE_CATEGORY_DELETE_API_REJECTED,
  TEMPLATE_CATEGORY_DELETE_START,
  TEMPLATE_CATEGORY_FETCH_TEMPLATES_API,
  TEMPLATE_CATEGORY_FETCH_TEMPLATES_API_FULFILLED,
  TEMPLATE_CATEGORY_FETCH_TEMPLATES_API_REJECTED,
  TEMPLATE_CATEGORY_FETCH_TEMPLATES_START,
  TEMPLATE_CATEGORY_UPDATE_API,
  TEMPLATE_CATEGORY_UPDATE_API_FULFILLED,
  TEMPLATE_CATEGORY_UPDATE_API_REJECTED,
  TEMPLATE_CATEGORY_UPDATE_START,
  TEMPLATE_CREATE_API,
  TEMPLATE_CREATE_API_FULFILLED,
  TEMPLATE_CREATE_API_REJECTED,
  TEMPLATE_CREATE_START,
  TEMPLATE_DELETE_API,
  TEMPLATE_DELETE_API_FULFILLED,
  TEMPLATE_DELETE_API_REJECTED,
  TEMPLATE_DELETE_START,
  TEMPLATE_INSTANCE_FETCH_API,
  TEMPLATE_INSTANCE_FETCH_START,
  TEMPLATE_UPDATE_API,
  TEMPLATE_UPDATE_API_FULFILLED,
  TEMPLATE_UPDATE_API_REJECTED,
  TEMPLATE_UPDATE_START,
  TEMPLATES_FETCH_API,
  TEMPLATES_FETCH_SEARCH_API,
  TEMPLATES_FETCH_SEARCH_START,
  TEMPLATES_FETCH_START,
  trackEvent
} from '../actions';
import {TEMPLATES_FILTER_PROPERTIES} from '../../constants/issue-query-params';
import {createIssueTemplate, getAssigneeTypeByAssigneeId} from '../../utils/analytics-helpers';
import {
  TEMPLATE_CATEGORY_FIELD_NAMES,
  TEMPLATE_FIELD_NAMES,
  TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES
} from '../../constants/issue-templates';
import {getTemplateCategoriesEntitiesMap} from './template-selectors';
import lodashGet from 'lodash/get';
import lodashHas from 'lodash/has';
import {getCurrentUserId, getIssueTypesAdminEntitiesMap, getOxygenMappings} from '../selectors';

export default issuesV2Api => store => next => action => {
  switch (action.type) {
    case TEMPLATE_CREATE_START:
      store.dispatch({
        type: TEMPLATE_CREATE_API,
        meta: action.meta,
        payload: issuesV2Api.createIssueTemplate(action.payload)
      });
      break;
    case TEMPLATE_CREATE_API_FULFILLED: {
      const template = action.payload;
      action.meta.onSuccess && action.meta.onSuccess(template);

      //MixPanel event - create new issue template
      const state = store.getState();
      const templateCategoriesEntitiesMap = getTemplateCategoriesEntitiesMap(state);
      const templateCategoryTitle = lodashGet(templateCategoriesEntitiesMap, [
        template[TEMPLATE_FIELD_NAMES.CATEGORY_ID],
        TEMPLATE_CATEGORY_FIELD_NAMES.TITLE
      ]);
      const templateSubtypeId = lodashGet(template, [
        TEMPLATE_FIELD_NAMES.ISSUE_ATTRIBUTES,
        TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES.SUBTYPE_ID
      ]);
      const issueTypesAdminEntitiesMap = getIssueTypesAdminEntitiesMap(state);
      const issueTypeId = templateSubtypeId && issueTypesAdminEntitiesMap[templateSubtypeId].parentId;
      const issueTypeTitle = issueTypeId && issueTypesAdminEntitiesMap[issueTypeId].title;
      const assignee = getAssigneeTypeByAssigneeId(
        lodashGet(template, [TEMPLATE_FIELD_NAMES.ISSUE_ATTRIBUTES, TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES.ASSIGNED_TO]),
        getCurrentUserId(state),
        getOxygenMappings(state),
        lodashGet(template, [
          TEMPLATE_FIELD_NAMES.ISSUE_ATTRIBUTES,
          TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES.ASSIGNED_TO_TYPE
        ])
      );
      const hasDueDate = lodashHas(template, [
        TEMPLATE_FIELD_NAMES.ISSUE_ATTRIBUTES,
        TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES.DUE_DATE
      ]);

      store.dispatch(trackEvent(createIssueTemplate(templateCategoryTitle, issueTypeTitle, assignee, hasDueDate)));
      break;
    }
    case TEMPLATE_CREATE_API_REJECTED:
      action.meta.onError && action.meta.onError();
      break;
    case TEMPLATE_UPDATE_START:
      store.dispatch({
        type: TEMPLATE_UPDATE_API,
        meta: action.meta,
        payload: issuesV2Api.updateIssueTemplate(action.payload.id, action.payload.attributes)
      });
      break;
    case TEMPLATE_UPDATE_API_FULFILLED:
      action.meta.onSuccess && action.meta.onSuccess(action.payload);
      break;
    case TEMPLATE_UPDATE_API_REJECTED:
      action.meta.onError && action.meta.onError();
      break;
    case TEMPLATE_DELETE_START:
      store.dispatch({
        type: TEMPLATE_DELETE_API,
        meta: {...action.meta, id: action.payload},
        payload: issuesV2Api.deleteIssueTemplate(action.payload)
      });
      break;
    case TEMPLATE_DELETE_API_FULFILLED:
      action.meta.onSuccess && action.meta.onSuccess();
      break;
    case TEMPLATE_DELETE_API_REJECTED:
      action.meta.onError && action.meta.onError();
      break;
    case TEMPLATE_INSTANCE_FETCH_START:
      store.dispatch({
        type: TEMPLATE_INSTANCE_FETCH_API,
        payload: issuesV2Api.getIssueTemplateById(action.payload)
      });
      break;
    case TEMPLATES_FETCH_START:
      store.dispatch({
        type: TEMPLATES_FETCH_API,
        payload: issuesV2Api.getIssueTemplates(action.payload)
      });
      break;
    case TEMPLATES_FETCH_SEARCH_START:
      store.dispatch({
        type: TEMPLATES_FETCH_SEARCH_API,
        payload: issuesV2Api.getIssueTemplates({
          [TEMPLATES_FILTER_PROPERTIES.SEARCH]: action.payload
        })
      });
      break;
    case TEMPLATE_CATEGORIES_FETCH_START:
      store.dispatch({
        type: TEMPLATE_CATEGORIES_FETCH_API,
        payload: issuesV2Api.getIssueTemplateCategories()
      });
      break;
    case TEMPLATE_CATEGORY_CREATE_START:
      store.dispatch({
        type: TEMPLATE_CATEGORY_CREATE_API,
        meta: action.meta,
        payload: issuesV2Api.createIssueTemplateCategory(action.payload)
      });
      break;
    case TEMPLATE_CATEGORY_CREATE_API_FULFILLED:
      action.meta.onSuccess && action.meta.onSuccess(action.payload);
      break;
    case TEMPLATE_CATEGORY_CREATE_API_REJECTED:
      action.meta.onError && action.meta.onError();
      break;
    case TEMPLATE_CATEGORY_UPDATE_START:
      store.dispatch({
        type: TEMPLATE_CATEGORY_UPDATE_API,
        meta: action.meta,
        payload: issuesV2Api.updateIssueTemplateCategory(action.payload.id, action.payload.attributes)
      });
      break;
    case TEMPLATE_CATEGORY_UPDATE_API_FULFILLED:
      action.meta.onSuccess && action.meta.onSuccess(action.payload);
      break;
    case TEMPLATE_CATEGORY_UPDATE_API_REJECTED:
      action.meta.onError && action.meta.onError();
      break;
    case TEMPLATE_CATEGORY_DELETE_START:
      store.dispatch({
        type: TEMPLATE_CATEGORY_DELETE_API,
        meta: action.meta,
        payload: issuesV2Api.deleteIssueTemplateCategory(action.payload.id, action.payload.templatesTarget)
      });
      break;
    case TEMPLATE_CATEGORY_DELETE_API_FULFILLED:
      action.meta.onSuccess && action.meta.onSuccess(action.payload);
      break;
    case TEMPLATE_CATEGORY_DELETE_API_REJECTED:
      action.meta.onError && action.meta.onError();
      break;
    case TEMPLATE_CATEGORY_FETCH_TEMPLATES_START:
      store.dispatch({
        type: TEMPLATE_CATEGORY_FETCH_TEMPLATES_API,
        payload: issuesV2Api.getIssueTemplates({
          [TEMPLATES_FILTER_PROPERTIES.CATEGORY]: action.payload
        }),
        meta: action.meta
      });
      break;
    case TEMPLATE_CATEGORY_FETCH_TEMPLATES_API_FULFILLED:
      action.meta.onSuccess && action.meta.onSuccess(action.payload);
      break;
    case TEMPLATE_CATEGORY_FETCH_TEMPLATES_API_REJECTED:
      action.meta.onError && action.meta.onError();
      break;
    default:
      break;
  }
  return next(action);
};
